import * as React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ReactComponent as CollabIllustration } from '../../images/illustrations/illustration-collab.svg';
import { ReactComponent as ForTeamsWallpaper } from '../../images/notebooks/for-teams-wallpaper.svg';
import { ANIMATIONS, INTERNAL_LINKS } from '../../utils';
import { Button, GradientHeader, Text } from '../design-system';

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: ${({ theme }) => theme.maxWidth.PAGE};
  width: 100%;
  padding: 80px 40px;
  position: relative;
  margin-bottom: 60px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    padding: 60px 0;
    margin-bottom: 130px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    padding: 0;
    margin-bottom: 80px;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 590px;
  padding: 0 40px;
`;

const CollabIcon = styled.div`
  display: flex;
  margin-bottom: 15px;
`;

const StyledHeading = styled(GradientHeader)`
  && {
    text-align: center;
    margin-bottom: 5px;

    span {
      display: block;

      @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
        display: inline;
      }
    }
  }
`;

const Wallpaper = styled.div`
  position: absolute;
  pointer-events: none;
`;

export const ForTeamsTout: React.ComponentType = React.memo(() => {
  return (
    <Wrapper {...ANIMATIONS.SimpleFadeIn}>
      <Info>
        <CollabIcon>
          <CollabIllustration />
        </CollabIcon>
        <StyledHeading $purple={true} renderAs="h1">
          Built for teams
        </StyledHeading>
        <Text
          css={`
            text-align: center;
          `}
          size="large">
          Hex is collaborative by default, and makes it easy to share your work
          as a beautiful report or data app anyone can use.
        </Text>
        <Button
          link={INTERNAL_LINKS.ForTeams}
          stylez="loud"
          text="Learn more"
        />
      </Info>
      <Wallpaper>
        <ForTeamsWallpaper />
      </Wallpaper>
    </Wrapper>
  );
});
